import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PillButton: FunctionComponent<Props> = ({
    ariaPressed,
    children,
    className = '',
    isDisabled = false,
    onClick,
    testId = TEST_ID
}) => (
    <button
        aria-pressed={ariaPressed}
        className={`${className} ${styles.pillButton}`}
        data-testid={testId}
        disabled={isDisabled}
        onClick={onClick}>
        {children}
    </button>
);

export default PillButton;
